export default __webpack_public_path__ + "static/media/RightTwoButton.fc957e7d.webp";